import { get, isNil } from 'lodash';
export function activeSegmentTypes(segmentTypes, industryTypes, activeIndustryTypes, segmentTypesValue) {
  const findIndustryById = (id) => {
    const industry = industryTypes.find(i => i.id === id) || {};
    return get(industry, 'name');
  };

  return segmentTypes
    .filter(s => isNil(s.parentId) || (activeIndustryTypes || []).includes(s.parentId) || (segmentTypesValue || []).includes(s.id))
    .map(s => ({...s, parentName: findIndustryById(s.parentId)}))
  ;
}



// WEBPACK FOOTER //
// ./shared/lib/industrySegments.js